import { formatNumber } from "./NumberUtils";

export default class TimeUtils {

	public static convertTime(seconds: number, fullTime: boolean = false) {
		let days = Math.floor(seconds / 1440);
		let hours = Math.floor((seconds - (days * 1440)) / 60);
		let minutes = Math.round(seconds % 60);

		if (fullTime) {
			return formatNumber(days) + " dní, " + hours + ":" + (minutes < 10 ? "0" + minutes : minutes);
		} else {
			if (days > 0) {
				return (formatNumber(days) + " dní");
			} else {
				return (hours + ":" + (minutes < 10 ? "0" + minutes : minutes));
			}
		}
	}
}
